import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { ActorDatabaseContext } from "@-/dev.improve.haniverse.contexts.database.actor";
import {
  tableNameMatcher,
  useTableChangeVersion,
} from "@-/dev.improve.haniverse.lib.database.change";
import { createUseQueryOptions } from "@-/dev.improve.haniverse.lib.query-options";
import { readXp } from "#read-xp";

/** Every table XP is derived from. */
export const XP_TABLE_NAMES = ["user_quest"];

function useGetXpQueryKey() {
  const [actorDb] = useContextSelectors(ActorDatabaseContext, (c) => c.db);
  const withTableChangeVersion = useTableChangeVersion(tableNameMatcher(XP_TABLE_NAMES));
  return () => withTableChangeVersion(["xp", { actorDb }] as const);
}

/** The learner's XP ({@link readXp}). */
export const [useXpQueryOptions] = createUseQueryOptions(
  useGetXpQueryKey,
  async ({ queryKey: [_, { actorDb }] }) => readXp(actorDb(import.meta.location)),
);
